export default {
    'Features': 'Features',
    'Solutions': 'Solutions',
    'Contact': 'Contact',
    'Partner': 'Partner',
    'Download': 'Download',
    'FAQ': 'FAQ',
    'Freetrial': 'Try It Free',
    'locale.en': 'English',
    'locale.zh-TW': 'Traditional Chinese',
    'locale.zh-CN': 'Simplified Chinese',
}